<mat-progress-bar
  mode="indeterminate"
  color="accent"
  *ngIf="show"
  class="loader-overlay"
></mat-progress-bar>